import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input
} from '@angular/core';

import styles from './VbScrubBarCurrentTimeBubble.module.less';

@Component({
	selector: 'vb-scrub-bar-current-time-bubble',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `<span>{{ currentTime | vbPlayerTime }}</span>`,
	host: {
		'[class]': 'styles.root'
	},
    standalone: false
})
export class VbScrubBarCurrentTimeBubbleComponent {
	@Input() public currentTime: number; // ms
	@Input() @HostBinding('class.vbScrubBarCurrentTimeBubbleIsLiveHide') public isLive: boolean;
	@Input() @HostBinding('style.left') public scrubBarPercentage: string;

	public readonly styles = styles;
}
